// extracted by mini-css-extract-plugin
module.exports = {"icon":"style__icon__6HSrp"};